/* eslint-disable react-hooks/rules-of-hooks */

import newMessage from "../../assets/sounds/newMessage.mp3";
import newConversation from "../../assets/sounds/newConversation.mp3";
import closeConversation from "../../assets/sounds/closeConversation.mp3";

export default class AudioComponent {
  static instance = null;
  _volume = parseInt(localStorage.Volume ?? "100");
  _notificationNewMessageSound = new Audio(newMessage)
  _notificationNewConversationSound = new Audio(newConversation)
  _notificationCloseConversationSound = new Audio(closeConversation)

  static get inst() {
    if (AudioComponent.instance == null) {
      AudioComponent.instance = new AudioComponent();
    }
    return this.instance;
  }

  static get volume() {
    return AudioComponent.inst._volume;
  }

  static setVolume(volume) {
    localStorage.setItem("Volume", volume);
    AudioComponent.inst._volume = volume;
    AudioComponent.inst._notificationNewMessageSound.volume = volume / 100
    AudioComponent.inst._notificationNewConversationSound.volume = volume / 100
    AudioComponent.inst._notificationCloseConversationSound.volume = volume / 100
  }

  static play(sound) {
    switch (sound) {
      case "newMessage":
        AudioComponent.inst._notificationNewMessageSound.play()
        break;
      case "newConversation":
        AudioComponent.inst._notificationNewConversationSound.play()
        break;
      case "closeConversation":
        AudioComponent.inst._notificationCloseConversationSound.play()
        break;
      default:
        AudioComponent.inst._notificationNewMessageSound.play()
        break;
    }
  }
}
